<dx-popup
  [visible]="isPopupVisible"
  position="center"
  [resizeEnabled]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  (onHiding)="onClosing()"
  contentTemplate="resultGrid"
  [width]="750"
  height="85vh"
  [titleTemplate]="'title'"
  #popup
>
  <div *dxTemplate="let i of 'title'" class="header">
    <div class="title">{{ researchType }}</div>
    <dx-button
      class="ml-auto"
      icon="close"
      (onClick)="popup.instance.hide()"
      stylingMode="text"
    ></dx-button>
  </div>
  <div *dxTemplate="let data of 'resultGrid'">
    <div class="mb-1">You searched for: "{{ searchTerm }}"</div>
    <dx-data-grid
      id="results"
      [dataSource]="records"
      [showBorders]="true"
      [showColumnLines]="true"
      [showRowLines]="true"
      [height]="460"
    >
      <dxo-paging [pageSize]="10" [pageIndex]="0"></dxo-paging>
      <dxo-header-filter [visible]="true"></dxo-header-filter>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      @if (researchType == "Resource") {
        <dxi-column
          dataField="name"
          caption="Name"
          [cellTemplate]="'clickableTemplate'"
          [allowFiltering]="true"
          [allowHeaderFiltering]="false"
          [allowSorting]="false"
          [fixed]="true"
        >
        </dxi-column>
        <dxi-column
          dataField="role"
          caption="Role"
          [allowFiltering]="false"
          [allowHeaderFiltering]="true"
          [allowSorting]="false"
          [fixed]="true"
        >
        </dxi-column>
        <dxi-column
          dataField="country"
          caption="Country"
          [allowFiltering]="false"
          [allowHeaderFiltering]="true"
          [allowSorting]="false"
          [fixed]="true"
        >
        </dxi-column>
      } @else {
        <dxi-column
          dataField="code"
          caption="Code"
          [allowFiltering]="true"
          [allowHeaderFiltering]="false"
          [allowSorting]="true"
          [cellTemplate]="'clickableTemplate'"
          [fixed]="true"
        >
        </dxi-column>
        <dxi-column
          dataField="customer"
          caption="Customer"
          [allowFiltering]="true"
          [allowHeaderFiltering]="false"
          [allowSorting]="true"
          [fixed]="true"
        >
        </dxi-column>
        <dxi-column
          dataField="name"
          caption="Name"
          [allowFiltering]="true"
          [allowHeaderFiltering]="false"
          [allowSorting]="true"
          [fixed]="true"
        >
        </dxi-column>
      }

      <div *dxTemplate="let row of 'clickableTemplate'">
        <span
          class="clickable"
          (click)="goTo(row.data['type'], row.data['id'])"
          >{{ row.data["code"] ?? row.data["name"] }}</span
        >
      </div>
    </dx-data-grid>
  </div>
</dx-popup>
